import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState } from "react";
import "../EditVendorModal/EditVendorModal.css";
import { VendorProduct } from "../../types/vendor";

interface UpdatePricingModalProps {
  product: VendorProduct;
  onClose: () => void;
  onSave: (data: { priceNGN?: number; priceGBP?: number }) => void;
  isSaving: boolean;
}

const UpdatePricingModal: React.FC<UpdatePricingModalProps> = ({
  product,
  onClose,
  onSave,
  isSaving,
}) => {
  const [fields, setFields] = useState({
    priceNGN: product.priceNGN || 0,
    priceGBP: product.priceGBP || 0,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: parseFloat(value) || 0 }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      priceNGN: fields.priceNGN,
      priceGBP: fields.priceGBP,
    });
  };

  return (
    <Modal title={<>Update Product Pricing</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <p style={{ marginBottom: "20px", color: "#6B7280", fontSize: "14px" }}>
          Set a price to 0 to make the product unavailable in that region.
        </p>

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div className="form-group">
              <label>Price (NGN)</label>
              <input
                type="number"
                name="priceNGN"
                value={fields.priceNGN}
                onChange={handleChange}
                min="0"
              />
            </div>

            <div className="form-group">
              <label>Price (GBP)</label>
              <input
                type="number"
                name="priceGBP"
                value={fields.priceGBP}
                onChange={handleChange}
                min="0"
              />
            </div>
          </div>

          <div className="modal-actions">
            <Button
              type="button"
              className="btn-cancel"
              onClick={onClose}
              disabled={isSaving}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? "Updating..." : "Save Changes"}
            </Button>
          </div>
        </form>
      </div>
</Modal>
  );
};

export default UpdatePricingModal;
